<template>
  <v-row justify="center">
    <v-col class="d-flex justify-start py-0 " cols="12">
       <v-select
          :items="items"
          item-text ="text"
          item-value="value"
          @change="changeSelect"
          label="Create Categories and Preferences"
          outlined
        ></v-select>
    </v-col>
    <v-col cols="12" md="12" class="pa-0">
      <router-view></router-view>
    </v-col>
  </v-row>
</template>
<script>
export default {
  computed: {},
  data: () => ({
    selected: '',
    items: [
      { text: 'Event Categories', value: 'EventCategories' },
      { text: 'Event Preferences', value: 'EventPreferences' },
      { text: 'Place Categories', value: 'PlaceCategories' },
      { text: 'Place Preferences', value: 'PlacePreferences' }
    ]
  }),
  methods: {
    changeSelect (value) {
      this.$router.push({ name: value })
    }
  }
}
</script>
